import { I18n } from "./hooks/useTranslations";

export const formatPrice = (
  price: number,
  locale: string | null,
  fractionDigits?: {
    min: number;
    max: number;
  },
): string => {
  const minimumFractionDigits = fractionDigits?.min;

  // the minimal fraction digits cannot be bigger than the maximal one
  // IF passed, it breaks, for that reason the guard:
  const maximumFractionDigits =
    fractionDigits && fractionDigits.min > fractionDigits.max ? fractionDigits?.max : fractionDigits?.min;

  return price.toLocaleString(locale ?? undefined, {
    currency: "EUR",
    style: "currency",
    minimumFractionDigits,
    maximumFractionDigits,
  });
};

export const getItemDescription = (
  item: {
    descriptionEn: string;
    descriptionIt: string | null;
    descriptionEs: string | null;
    descriptionFr: string | null;
    descriptionDe: string | null;
  },
  locale: string | null,
): string => {
  const lang = locale?.slice(0, 2).toLowerCase();
  switch (lang) {
    case "it":
      return item.descriptionIt || item.descriptionEn;
    case "es":
      return item.descriptionEs || item.descriptionEn;
    case "fr":
      return item.descriptionFr || item.descriptionEn;
    case "de":
      return item.descriptionDe || item.descriptionEn;
    default:
      return item.descriptionEn;
  }
};

export const formatViewName = (view: string, i18n: I18n): string => {
  switch (view) {
    case "helmets":
      return i18n.t.common.helmets;
    case "all-requests":
      return i18n.t.common.allRequests;
    default:
      return view;
  }
};

export const formatMinutes = (minutes: number, locale: string | null) => {
  return minutes.toLocaleString(locale ?? undefined);
};

export const getHourlyCostFromMinutes = (minutes: number, costPerHour: number) => {
  return (minutes / 60) * costPerHour;
};

export const downloadFileFromData = (data: string, fileName: string, contentType?: string) => {
  const toString = function (a: Object) {
    return String(a);
  };

  const myBlob = (window.Blob || toString).bind(window);

  const anchor = document.createElement("a");

  const d = window.atob(data);

  const tType = contentType || "application/octet-stream";

  if (/([\x80-\xff])/.test(d)) {
    const tempUiArr = new Uint8Array(d.length);
    const mx = tempUiArr.length;

    for (let i = 0; i < mx; i++) {
      tempUiArr[i] = d.charCodeAt(i);
    }

    const o = new myBlob([tempUiArr], { type: tType });
    anchor.href = window.URL.createObjectURL(o);
  } else {
    const o = new myBlob([d || ""], { type: tType });
    anchor.href = window.URL.createObjectURL(o);
  }

  anchor.setAttribute("download", fileName);
  anchor.className = "download-js-link";
  anchor.innerHTML = "downloading...";
  anchor.style.display = "none";
  document.body.appendChild(anchor);

  setTimeout(function () {
    anchor.click();
    document.body.removeChild(anchor);
    setTimeout(function () {
      window.URL.revokeObjectURL(anchor.href);
    }, 250);
  }, 66);

  return true;
};

export const isImage = (fileName: string) => {
  return ["png", "jpg", "gif", "jpeg", "tif", "svg"].some((x) => fileName.toLocaleLowerCase().split(".").pop() === x);
};
export const isVideo = (fileName: string) => {
  return ["mp3", "mp4", "avi"].some((x) => fileName.toLocaleLowerCase().split(".").pop() === x);
};
export const isPdf = (fileName: string) => {
  return fileName.toLocaleLowerCase().endsWith(".pdf");
};
